export default __webpack_public_path__ + "static/media/Snd_TryY.76fbc1cc.mp3";